import {
  Column,
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  ExcelExport,
  FilterSettingsModel,
  GridComponent,
  Group,
  PageSettingsModel,
  RowSelectEventArgs,
} from '@syncfusion/ej2-react-grids';

import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import {
  Edit,
  Filter,
  Page,
  ColumnMenu,
  Resize,
  Inject,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import Message from '../../../../utils/Message/Message';
import './campany-portfolio.css';
import {
  TextBoxComponent,
  UploaderComponent,
} from '@syncfusion/ej2-react-inputs';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { editusers, getusers } from '../../../../services/Users/Users';
import DigServices from '../../../../services/Dig/DigServices';
import { getValue } from '@syncfusion/ej2-base';
import { all_information, loadingShow } from '../../../../App';
import ReactDOM from 'react-dom';
import { FiChevronDown } from 'react-icons/fi';
import { IoAddOutline } from 'react-icons/io5';
import { MdOutlinePlaylistAdd } from 'react-icons/md';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import { BsCheck2All } from 'react-icons/bs';
import AUM from '../AUM';
import { ThemeContext } from '../../../../context/theme.context';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  AddAppComponent,
  getComponentS,
} from '../../../../services/Components/ComponentServices';
import axios from 'axios';
import {
  AddCampany,
  DeleteCampany,
  EditCampany,
  getCompany,
  getSites,
} from '../../../../services/Company/CompanyServices';
import { AddDepartment, EditDepartment, getDepartment } from '../../../../services/Department/DepartmentServices';
interface IProps {
  onRowSelect?: Function;
  isOnlyCompany?: boolean;
}
interface IState {
  hideDialog: boolean;
  hideDialogUsersList: boolean;
  hideDialogComponentList: boolean;
  hideDialogSitesAdd: boolean;
  hideDialogDepartmentAdd: boolean;
  hideDialogDeleteCompany: boolean;
  registrationStatus: number;
  CompanyData: any;
  CompanySitesData: any;
  SitesTempData: any;
  UsersListCheckboxData: any;
  UsersAllData: any;
  UsersTempData: any;
  showListUser: boolean;
  showTabsSitesAndDepartment: boolean;
  DepartmentAllData: any;
  DepartmentTempData: any;
  ComponentsListCheckboxData: any;
  ComponentsAllData: any;
  ComponentsOrgAllData: any;
  ComponentsTempData: any;
  companyName: any;
  abc: any;
  abn: any;
  paymetnTerms: any;
  registrationStartDate: any;
  registrationEndDate: any;
  activeStatus: boolean;
  inactiveStatus: boolean;
  warningStatus: boolean;
  statusHide: boolean;
  isEdit: boolean;
  richInternalValue: any;
  richGeneralValue: any;
  richAccountValue: any;
  ci: any;
  allow: any;
  adaptor: any;
  adaptorData: any;
}
export default class CampanyPortfolio extends Component<IProps, IState> {
  private DigServices = new DigServices();

  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  public path: object = {
    removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove',
    saveUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Save',
  };
  public toolbarOptions = [
    /* {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    }, */
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private buttons: ButtonPropsModel[];
  private buttonsUsersList: ButtonPropsModel[];
  private buttonForAdd: ButtonPropsModel[];
  private buttonForDelete: ButtonPropsModel[];
  private buttonForAddDepartment: ButtonPropsModel[];
  private buttonsComponentList: ButtonPropsModel[];
  private fields: object = { text: 'AdaptorName', value: 'AdaptorID' };
  private listObj: any;
  private grid: any;
  private animationSettings: AnimationSettingsModel;
  private site_code: string = '';
  private description: string = '';
  private department_code: string = '';
  private descriptionDepartment: string = '';
  private status: boolean = false;
  private statusDepartment: boolean = false;
  private textareaObjGeneral: any;
  private textareaObjAccount: any;
  private textareaObjInternal: any;
  static contextType = ThemeContext;
  private _isMounted: boolean = false;
  context!: React.ContextType<typeof ThemeContext>;
  public static companyId: number = -1;
  private source = axios.CancelToken.source();
  constructor(props: IProps) {
    super(props);
    this.state = {
      hideDialog: false,
      hideDialogUsersList: false,
      hideDialogSitesAdd: false,
      hideDialogComponentList: false,
      hideDialogDeleteCompany: false,
      registrationStatus: 0, //0 aktive 1 inaktive 2 warning
      CompanyData: [],
      CompanySitesData: [],
      SitesTempData: [],
      UsersListCheckboxData: [],
      UsersAllData: [],
      UsersTempData: [],
      showTabsSitesAndDepartment: true,
      showListUser: false,
      DepartmentAllData: [],
      DepartmentTempData: [],
      hideDialogDepartmentAdd: false,
      ComponentsListCheckboxData: [],
      ComponentsAllData: [],
      ComponentsTempData: [],
      companyName: '',
      abc: '',
      abn: '',
      paymetnTerms: '',
      registrationEndDate: '',
      registrationStartDate: '',
      statusHide: false,
      activeStatus: false,
      inactiveStatus: false,
      warningStatus: false,
      isEdit: false,
      ComponentsOrgAllData: [],
      richInternalValue: '',
      richGeneralValue: '',
      richAccountValue: '',
      ci: -1,
      allow: false,
      adaptor: {},
      adaptorData: [],
    };
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttons = [
      {
        click: () => {
          this.addCompany();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsUsersList = [
      {
        click: () => {
          this.setState({ hideDialogUsersList: false });
        },
        buttonModel: {
          content: 'Done',
          isPrimary: true,
        },
      },
    ];
    this.buttonForAdd = [
      {
        click: () => {
          this.addSite();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.dialogCloseSiteAdd();
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonForDelete = [
      {
        click: () => {
          this.deleteCompany();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDeleteCompany: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonForAddDepartment = [
      {
        click: () => {
          this.addDepartment();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.dialogCloseDepartmentAdd();
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.buttonsComponentList = [
      {
        click: () => {
          this.setState({ hideDialogComponentList: false });
        },
        buttonModel: {
          content: 'Done',
          isPrimary: true,
        },
      },
    ];
  }
  deleteCompany = async () => {
    const companyId = this.grid.getSelectedRecords()[0].id;
    const obj = {
      organization_id: companyId,
    };
    DeleteCampany(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Delete Successfully');
        this.getCompany();
        this.setState({ hideDialogDeleteCompany: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  };
  getDeparments() {
    getDepartment().then((res) => {
      //(res.data);
      const model = res.data.map((department: any) => {
        return {
          id: department.department_id,
          text: department.department_code,
          company_id: department.organization_id,
          description: department.description,
          status: department.status,
          color: department.status ? '#339933' : '#C90016',
          departmentActiveText: department.status ? 'ACTIVE' : 'INACTIVE',
        };
      });
      if (this._isMounted) {
        this.setState({ DepartmentAllData: model });
      }
    });
  }
  addDepartment() {
    if (this.department_code === '') {
      Message.error('Departmant cannot be empty');
      return;
    }
    if (this.descriptionDepartment === '') {
      Message.error('Description cannot be empty');
      return;
    }
    loadingShow(true, 'Adding');
    const data = this.grid.getSelectedRecords()[0];
    const obj = {
      status: this.statusDepartment,
      description: this.descriptionDepartment,
      organization_code: data.text,
      department_code: this.department_code,
      organization_id: data.id,
    };
    AddDepartment(obj)
      .then((res) => {
        loadingShow(false);
        this.getCompany();
        this.getUsers();
        this.getDeparments();
        this.dialogCloseDepartmentAdd();
        this.getDepartmentTemp(data.id);
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  getDepartmentTemp(companyId: any) {
    loadingShow(true);
    this.getDeparments();
    setTimeout(() => {
      let dataDepartment: any = [];
      this.state.DepartmentAllData.map((item: any) => {
        if (item.company_id === companyId) {
          dataDepartment.push(item);
        }
      });
      this.setState({ DepartmentTempData: dataDepartment });
      loadingShow(false);
    }, 2000);
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.setState({
        hideDialog: true,
        statusHide: false,
        isEdit: false,
        companyName: '',
        registrationStartDate: '',
        registrationEndDate: '',
        abc: '',
        abn: '',
        paymetnTerms: '',
      });
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        const data = this.grid.getSelectedRecords()[0];
        this.setState({
          companyName: data.text,
          registrationStartDate: data.REGISTRATION_START,
          registrationEndDate: data.REGISTRATION_END,
          abc: data.ABC,
          abn: data.ABN,
          paymetnTerms: data.PaymentTerms,
          statusHide: true,
          activeStatus: data.Status_Id === 0 ? true : false,
          inactiveStatus: data.Status_Id === 1 ? true : false,
          warningStatus: data.Status_Id === 2 ? true : false,
          hideDialog: true,
          isEdit: true,
          adaptor: {
            AdaptorID: data.Adaptor_Id,
            AdaptorName: data.adaptor_name,
          },
        });
      } else {
        Message.error('No records selected for edited operation');
      }
    }
    if (args.item.id === 'delete') {
      if (this.grid.getSelectedRecords().length !== 0) {
        this.setState({ hideDialogDeleteCompany: true });
      } else {
        Message.error('No records selected for edited operation');
      }
    }
    if (args.item.id === 'refresh') {
      this.getCompany();
    }
    if (this.grid && args.item.id === 'gridCompanyPor_excelexport') {
      this.grid.excelExport();
    }
  }
  begin(args: any) {
    if (args.requestType === 'beginEdit') {
      alert('edit');
    }
    if (args.requestType === 'save') {
      alert('save');
    }
  }
  private dialogClose(): void {
    this.setState({
      hideDialog: false,
    });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }
  private dialogCloseUsersList(): void {
    this.setState({
      hideDialogUsersList: false,
    });
  }
  private dialogOpenUserList(): void {
    if (this.grid.getSelectedRecords().length !== 0) {
      const id = this.grid.getSelectedRecords()[0].id;
      let data: any = [];
      this.state.UsersAllData.map((item: any) => {
        if (item.company_id === id) {
          data.push(item);
        }
      });
      if (data.length > 0) {
        this.setState({
          UsersListCheckboxData: data,
          hideDialogUsersList: true,
        });
      } else {
        Message.info('Not available');
      }
    } else {
      Message.error('No records selected for edited operation');
    }
  }
  private dialogCloseComponentList(): void {
    this.setState({
      hideDialogComponentList: false,
    });
  }
  private dialogOpenComponentList(): void {
    if (this.grid.getSelectedRecords().length !== 0) {
      const selectData = this.grid.getSelectedRecords()[0];
      const companyId = selectData.id;
      const selectComponent = this.state.ComponentsOrgAllData.filter(
        (x: any) => x.company_id === companyId
      );
      let temp: any = [];
      temp = Object.create(this.state.ComponentsAllData);
      selectComponent.map((itemOrg: any) => {
        temp.map((item: any, index: number) => {
          if (item.id === itemOrg.component_id) {
            item.isChecked = true;
          }
        });
      });
      this.setState({
        ComponentsListCheckboxData: temp,
        hideDialogComponentList: true,
      });
    } else {
      Message.error('No records selected for edited operation');
    }
  }
  private dialogCloseSiteAdd(): void {
    this.setState({
      hideDialogSitesAdd: false,
    });
  }
  private dialogOpenSiteAdd(): void {
    $('#siteName').val('');
    $('#siteDesc').val('');
    if (this.grid.getSelectedRecords().length !== 0) {
      this.setState({ hideDialogSitesAdd: true });
    } else {
      Message.error('No records selected for edited operation');
    }
  }
  private dialogCloseDepartmentAdd(): void {
    this.setState({
      hideDialogDepartmentAdd: false,
    });
  }
  private dialogOpenDepartmentAdd(): void {
    $('#departmentName').val('');
    $('#departmentDesc').val('');

    if (this.grid.getSelectedRecords().length !== 0) {
      this.setState({ hideDialogDepartmentAdd: true });
    } else {
      Message.error('No records selected for edited operation');
    }
  }
  getUsers() {
    getusers().then((res) => {
      const model = res.data.map((result: any) => {
        return {
          id: result.user_id,
          first_name: result.first_name,
          last_name: result.last_name,
          text: result.first_name + ' ' + result.last_name,
          company_id: result.company_id,
          email: result.email,
          status: result.status_id,
          contactNumber: result.contact_number,
          isAdmin: result.isAdmin,
          isApprover: result.isAprover,
          isSupport: result.isSupport,
          application_user_id: result.application_user_id,
          assignment_id: result.assignment_id,
          assignment_security_roles_id: result.assignment_security_roles_id,
          company_name: result.company_name,
          department_id: result.department_id,
          department_name: result.department_name,
          description: result.description,
          locale: result.locale,
          lock_account: result.lock_account,
          organization_id: result.organization_id,
          password: result.password,
          site_id: result.site_id,
          site_name: result.site_name,
          color: result.status_id ? '#339933' : '#C90016',
          usersActiveText: result.status_id ? 'ACTIVE' : 'INACTIVE',
          isChecked: result.isSupport,
        };
      });
      if (this._isMounted) {
        this.setState({ UsersAllData: model });
      }
    });
  }

  convertDate = (val: any) => {
    var str = val;
    var num = parseInt(str?.substring(6, 19));
    //var num = parseInt(str.replace(/[^09]/g, ""));
    var date = new Date(num);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    const result =
      (day < 10 ? '0' + day : day) +
      '/' +
      (month < 10 ? '0' + month : month) +
      '/' +
      year;
    return result;
  };
  onChangeRegistrationDate = () => {
    const registrationStart = $('#registrationStartDate').val() as string;
    const registrationEnd = $('#registrationEndDate').val() as string;
    const dateNow = new Date().toLocaleDateString('en-US').replaceAll('.', '/');

    let active = false;
    let inactive = false;
    let warning = false;
    let statusHide = false;
    var durum = 0;
    if (registrationStart != '' && registrationEnd != '') {
      statusHide = true;
      var startDate = registrationStart.split('/');
      var endDate = registrationEnd.split('/');
      var now = dateNow.split('/');
      var from = new Date(
        parseInt(startDate[2]),
        parseInt(startDate[1]) - 1,
        parseInt(startDate[0])
      ); // -1 because months are from 0 to 11
      var to = new Date(
        parseInt(endDate[2]),
        parseInt(endDate[1]) - 1,
        parseInt(endDate[0])
      );
      var check = new Date(
        parseInt(now[2]),
        parseInt(now[0]) - 1,
        parseInt(now[1])
      );
      if (to < from) {
        Message.error(
          " Registration End Date can't be small Registration Start Date"
        );
        $('#registrationEndDate').val(' ');
        this.setState({ statusHide: false });
        return false;
      }
      if ((check >= from && check <= to) === true) {
        //sistem tarihi baslangic ve bitis tarihleri arasinda ise aktif
        const zamanFark = Math.abs(
          new Date(to).getTime() - new Date(check).getTime()
        );
        const gunfark = Math.ceil(zamanFark / (1000 * 3600 * 24));
        if (gunfark <= 30) {
          //bitis tarihini bitistarihinden cikarinca 30 dan kucukse warning
          active = false;
          inactive = false;
          warning = true;
          durum = 2;
        } else {
          active = true;
          inactive = false;
          warning = false;
          durum = 0;
        }
      }
      if ((check >= from && check <= to) === false) {
        //sistem tarihi baslangic ve bitis tarihleri arasinda degil ise inaktif
        active = false;
        inactive = true;
        warning = false;
        durum = 1;
      }
    } else {
      statusHide = false;
    }
    this.setState({
      registrationStatus: durum,
      statusHide: statusHide,
      activeStatus: active,
      inactiveStatus: inactive,
      warningStatus: warning,
    });
  };
  addCompany = () => {
    const startDate = $('#registrationStartDate').val() as string;
    const endDate = $('#registrationEndDate').val() as string;
    const companyName = $('#companyName').val() as string;
    const abc = $('#abc').val() as string;
    const abn = $('#abn').val() as string;
    const paymentTerms = $('#paymentTerms').val() as string;
    const adaptorID = this.state.adaptor.AdaptorID;
    const adaptorName = this.state.adaptor.AdaptorName;
    var sDateSplit = startDate.split('/');
    var eDateSplit = endDate.split('/');
    var from = new Date(
      parseInt(sDateSplit[2]),
      parseInt(sDateSplit[1]) - 1,
      parseInt(sDateSplit[0])
    ); // -1 because months are from 0 to 11
    var to = new Date(
      parseInt(eDateSplit[2]),
      parseInt(eDateSplit[1]) - 1,
      parseInt(eDateSplit[0])
    );

    let message = '';
    if (startDate == '') {
      message = 'Can not be empty registration start date';
      Message.error(message);
      return false;
    }
    if (endDate == '') {
      message = 'Can not be empty registration end date';
      Message.error(message);
      return false;
    }
    if (companyName == '') {
      message = 'Can not be empty company name';
      Message.error(message);
      return false;
    }
    if (abc == '') {
      message = 'Can not be empty abc';
      Message.error(message);
      return false;
    }
    if (abn == '') {
      message = 'Can not be empty abn';
      Message.error(message);
      return false;
    }
    if (paymentTerms == '') {
      message = 'Can not be empty payment terms';
      Message.error(message);
      return false;
    }
    loadingShow(true);
    const status = this.state.registrationStatus;
    const sDate = new Date(from);
    const eDate = new Date(to);
    const data = this.grid.getSelectedRecords()[0];
    const obj = {
      effective_start_date: sDate,
      effective_end_date: eDate,
      CompanyName: companyName,
      Abc: abc,
      Abn: abn,
      PaymentTerms: paymentTerms,
      Status_Id: status,
      isParent: true,
      Description: '',
      parent_organization_id: 0,
      primary_contact: data?.primary_contact,
      country: data?.country,
      city: data?.city,
      postal_code: data?.postal_code,
      contact_number: data?.contact_number,
      state_province: data?.state_province,
      adress_line_2: data?.adress_line_2,
      adress_line_1: data?.adress_line_1,
      biling_org_name: data?.biling_org_name,
      email: data?.email,
      generalNot: data?.generalNot,
      accountNot: data?.accountNot,
      internalNot: data?.internalNot,
      organization_id: this.state.isEdit ? data?.id : undefined,
      organization_code: companyName,
      adaptor_id: adaptorID,
      adaptor_name: adaptorName,
      app: 'UWORK',
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
    if (!this.state.isEdit) {
      AddCampany(obj)
        .then((res) => {
          this.setState({ CompanyData: res.data });
          loadingShow(false);
          Message.success('Successfully');
          this.getCompany();
          this.dialogClose();
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditCampany(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.setState({ CompanyData: res.data });
          this.getCompany();
          this.dialogClose();
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  };
  cellRender = (args: any) => {
    if ((args.column as Column).field === 'Status_Id') {
      const val = getValue((args.column as Column).field, args.data);
      let color = '';
      let textColor = '';
      let text = '';
      if (val === 0) {
        color = '#339933';
        text = 'ACTIVE';
        textColor = 'white';
      } else if (val === 1) {
        color = '#C90016';
        text = 'INACTIVE';
        textColor = 'white';
      } else if (val === 2) {
        color = '#FFCA2C';
        text = 'WARNING';
        textColor = 'black';
      }
      ReactDOM.render(
        <div
          style={{
            backgroundColor: color,
            padding: '5px',
            textAlign: 'center',
            color: textColor,
            borderRadius: '5px',
          }}
        >
          {text}
        </div>,
        args.cell as Element
      );
    }
  };
  getComponents = async () => {
    const model = await getComponentS().then((result: any) => {
      return result.data?.map((item: any) => {
        return {
          id: item.ID,
          description: item.component_description,
          Status: item.Status,
          text: item.component_name,
          isChecked: item.Status,
        };
      });
    });
    if (this._isMounted) {
      this.setState({ ComponentsAllData: model });
    }
  };
  getOrgComponents = async () => {
    const model = await getComponentS().then((result: any) => {
      return result.data.map((item: any) => {
        return {
          company_id: item.company_id,
          id: item.ID,
          description: item.Description,
          component_id: item.component_id,
          Status: item.Status,
          text: item.component_name,
          isChecked: false,
        };
      });
    });
    if (this._isMounted) {
      this.setState({ ComponentsOrgAllData: model });
    }
  };
  getAdaptor() {
    this.DigServices.getSourceAdaptors(
      { org_id: all_information.company_id },
      this.source
    ).then((result) => {
      if (this._isMounted) {
        this.setState({ adaptorData: result.data });
      }
    });
  }
  componentDidMount() {
    this._isMounted = true;
    this.getAdaptor();
    this.getComponents();
    this.getCompany();
    this.getUsers();
    this.getDeparments();
    this.getOrgComponents();
    this.getSitess();
    $('.collapse-sectionTwo-icon').click(function () {
      $('.content-show-sectionTwo').toggleClass('show');
      $('#rotate-icon').toggleClass('rotateIcon');
    });
    $('.tab-button-company').click(function () {
      const current = $(this);
      $('.tab-button-company').removeClass('active-tab-button');
      current.addClass('active-tab-button');

      let control = true;
      if (current.text() === 'Sites') {
        $('#showTabSite').css('display', 'block');
        $('#showTabDepartment').css('display', 'none');
      } else {
        $('#showTabSite').css('display', 'none');
        $('#showTabDepartment').css('display', 'block');
      }
    });
  }
  public rowselect(args: RowSelectEventArgs): void {
    this.props.onRowSelect && this.props.onRowSelect(args);
    if (this.props.isOnlyCompany) return;
    this.setState({ ComponentsTempData: [] });
    this.state.ComponentsAllData.map((item: any) => {
      item.isChecked = false;
    });
    this.fillInputBillingInformation();
    this.getCompany();
    let selRecord: any = args.data;
    this.textareaObjAccount &&
      (this.textareaObjAccount.value = selRecord?.accountNot);
    this.textareaObjInternal &&
      (this.textareaObjInternal.value = selRecord?.internalNot);
    this.textareaObjGeneral &&
      (this.textareaObjGeneral.value = selRecord?.generalNot);

    let dataSites: any = [];
    let dataUsers: any = [];
    let dataDepartments: any = [];
    let dataComponents: any = [];
    const companyId = selRecord.id;
    this.state.CompanySitesData.map((item: any) => {
      if (item.s_parent_organization_id === companyId) {
        dataSites.push(item);
      }
    });
    this.state.UsersAllData.map((item: any) => {
      if (item.company_id === companyId && item.isSupport === true) {
        dataUsers.push(item);
      }
    });

    this.state.DepartmentAllData.map((item: any) => {
      if (item.company_id === companyId.toString()) {
        dataDepartments.push(item);
      }
    });
    this.state.ComponentsOrgAllData.map((item: any) => {
      if (item.company_id === companyId) {
        const obj = {
          id: companyId,
          Description: item.description,
          text: item.text,
          component_id: item.component_id,
          Status: item.Status,
          isDeleted: true,
          isChecked: false,
        };
        dataComponents.push(obj);
      }
    });
    this.setState({
      SitesTempData: dataSites,
      UsersTempData: dataUsers,
      DepartmentTempData: dataDepartments,
      ComponentsTempData: dataComponents,
      allow: true,
      ci: { allow: true, company_id: companyId },
    });
  }
  public clickActionStatus(id: any) {
    let data: any = [];
    this.state.SitesTempData.map((item: any) => {
      if (item.id === id) {
        item.Status = !item.Status;
        item.color = item.Status ? '#339933' : '#C90016';
        item.sitesActiveText = item.Status ? 'ACTIVE' : 'INACTIVE';
      }
      data.push(item);
    });
    if (data.length > 0) {
      this.getUpdateData(data);
    }
  }
  getUpdateData(data: any) {
    this.setState({ SitesTempData: data });
  }
  genericSitesId(id: any): string {
    return 'sites_' + id;
  }
  sitesTemplate = (el: any) => {
    return (
      <div key={Math.random()} className='containerCollapse'>
        <div
          id={this.genericSitesId(el.id)}
          className='collasibleSites'
          onClick={() => this.clickCollapseSite(el.id)}
        >
          <div className='collapsible-first-item'>
            <div
              style={{ backgroundColor: el.color }}
              className='status-span'
            ></div>
            <div style={{ marginTop: '6px' }}>
              <label className='text-color'>{el.site_name}</label>
            </div>
          </div>
          <div className='collasible-second-item'>
            <FiChevronDown size={20} />
          </div>
        </div>
        <div className='collasibleSitesContent'>
          <label className='text-sub-color'>Status:</label>
          <button
            onClick={() => this.clickActionStatus(el.id)}
            style={{ backgroundColor: el.color }}
            className='status-action'
          >
            {el.sitesActiveText}
          </button>
        </div>
      </div>
    );
  };

  clickCollapseSite = (id: any) => {
    const t = $(`#sites_${id}`);
    t.next().toggleClass('show');
    t.children().next('.collasible-second-item').toggleClass('toggle-rotate');
    $('.collasibleSites').parent().removeClass('active-item');
    t.parent().addClass('active-item');
  };
  clickCollapseDepartment = (id: any) => {
    const t = $(`#department_${id}`);
    t.next().toggleClass('show');
    t.children().next('.collasible-second-item').toggleClass('toggle-rotate');
    $('.collasibleDepartment').parent().removeClass('active-item');
    t.parent().addClass('active-item');
  };
  genericDepartmentId(id: any): string {
    return 'department_' + id;
  }
  public clickActionDepartmentStatus(id: any) {
    let data: any = [];
    this.state.DepartmentTempData.map((item: any) => {
      if (item.id === id) {
        item.status = !item.status;
        item.color = item.status ? '#339933' : '#C90016';
        item.departmentActiveText = item.status ? 'ACTIVE' : 'INACTIVE';
      }
      data.push(item);
    });
    if (data.length > 0) {
      this.getUpdateDepartmentData(data);
    }
  }
  getUpdateDepartmentData(data: any) {
    this.setState({ DepartmentTempData: data });
  }
  departmentTemplate = (el: any) => {
    return (
      <div key={Math.random()} className='containerCollapse'>
        <div
          id={this.genericDepartmentId(el.id)}
          className='collasibleDepartment'
          onClick={() => this.clickCollapseDepartment(el.id)}
        >
          <div className='collapsible-first-item'>
            <div
              style={{ backgroundColor: el.color }}
              className='status-span'
            ></div>
            <div style={{ marginTop: '6px' }}>
              <label className='text-color'>{el.text}</label>
            </div>
          </div>
          <div className='collasible-second-item'>
            <FiChevronDown size={20} />
          </div>
        </div>
        <div className='collasibleDepartmentContent'>
          <label className='text-sub-color'>Status:</label>
          <button
            onClick={() => this.clickActionDepartmentStatus(el.id)}
            style={{ backgroundColor: el.color }}
            className='status-action'
          >
            {el.departmentActiveText}
          </button>
        </div>
      </div>
    );
  };
  gridOnFocus = () => {
    if (this.grid.getSelectedRecords().length !== 0) {
      $('.content-show-sectionTwo').addClass('show');
      $('#rotate-icon').addClass('rotateIcon');
      $('#collapse-sectionTwoIcon').prop('disabled', true);
    } else {
      $('.content-show-sectionTwo').removeClass('show');
      $('#rotate-icon').removeClass('rotateIcon');
      this.setState({
        UsersTempData: [],
        SitesTempData: [],
        DepartmentTempData: [],
        ComponentsTempData: [],
      });
      this.CleanInputBillingInformation();
      $('#collapse-sectionTwoIcon').prop('disabled', false);
    }
  };
  clickCollapseUser = (id: any) => {
    const t = $(`#user_${id}`);
    t.next().toggleClass('show');
    t.children()
      .next('.collasible-users-second-item')
      .toggleClass('toggle-rotate');
    $('.collasibleUsers').parent().removeClass('active-item');
    t.parent().addClass('active-item');
  };
  genericUserId(id: any): string {
    return 'user_' + id;
  }
  public clickActionUsersStatus(id: any) {
    let data: any = [];
    this.state.UsersTempData.map((item: any) => {
      if (item.id === id) {
        item.status = !item.status;
        item.color = item.status ? '#339933' : '#C90016';
        item.usersActiveText = item.status ? 'ACTIVE' : 'INACTIVE';
      }
      data.push(item);
    });
    if (data.length > 0) {
      this.getUpdateUserData(data);
    }
  }
  clickActionUserAdmin = (id: any) => {
    let data: any = [];
    this.state.UsersTempData.map((item: any) => {
      if (item.id === id) {
        item.isAdmin = !item.isAdmin;
      }
      data.push(item);
    });
    if (data.length > 0) {
      this.getUpdateUserData(data);
    }
  };
  clickActionUserApprover = (id: any) => {
    let data: any = [];
    this.state.UsersTempData.map((item: any) => {
      if (item.id === id) {
        item.isApprover = !item.isApprover;
      }
      data.push(item);
    });
    if (data.length > 0) {
      this.getUpdateUserData(data);
    }
  };
  getUpdateUserData(data: any) {
    this.setState({ UsersTempData: data });
  }
  usersTemplate = (el: any) => {
    return (
      <div key={Math.random()} className='containerCollapseUsers'>
        <div
          id={this.genericUserId(el.id)}
          className='collasibleUsers'
          onClick={() => this.clickCollapseUser(el.id)}
        >
          <div className='collapsible-users-first-item'>
            <div
              style={{ backgroundColor: el.color }}
              className='status-span'
            ></div>
            <div style={{ marginTop: '6px' }}>
              <label className='text-color'>{el.text}</label>
            </div>
          </div>
          <div className='collasible-users-second-item'>
            <FiChevronDown size={20} />
          </div>
        </div>
        <div className='collasibleUsersContent'>
          <div className='collasibleUserSubContent'>
            <div className='contact-user'>
              <div>
                <label className='text-sub-color '>Contact Number : </label>
                <label className=' explain-label'>{el.contactNumber}</label>
              </div>
              <div>
                <label className='text-sub-color '>Email : </label>
                <label className=' explain-label'>{el.email}</label>
              </div>
            </div>
            <div className='action-content-user'>
              <div>
                <label className='text-sub-color'>Status : </label>
                <button
                  onClick={() => this.clickActionUsersStatus(el.id)}
                  style={{ backgroundColor: el.color }}
                  className='status-action'
                >
                  {el.usersActiveText}
                </button>
              </div>
              <div className='action-content-sub-user'>
                <div>
                  <label className='text-sub-color'>Roles : </label>
                </div>
                <div>
                  <button
                    id='adminUser'
                    className='status-action'
                    onClick={() => this.clickActionUserAdmin(el.id)}
                  >
                    {el.isAdmin ? (
                      <div>
                        <label
                          style={{ color: '#000' }}
                          className='text-sub-color'
                        >
                          ADMIN
                        </label>
                        <BsCheck2All size={18} color='white' />
                      </div>
                    ) : (
                      <label
                        style={{ color: '#000' }}
                        className='text-sub-color'
                      >
                        ADMIN
                      </label>
                    )}
                  </button>
                  <button
                    id='approverUser'
                    className='status-action'
                    onClick={() => this.clickActionUserApprover(el.id)}
                  >
                    {el.isApprover ? (
                      <div>
                        <label
                          style={{ color: 'white' }}
                          className='text-sub-color'
                        >
                          APPROVER
                        </label>
                        <BsCheck2All size={18} color='white' />
                      </div>
                    ) : (
                      <label
                        style={{ color: 'white' }}
                        className='text-sub-color'
                      >
                        APPROVER
                      </label>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  oncChanceListUsers(args: any) {
    let userTempData = this.state.UsersTempData;
    let selectData: any = args.data;
    const isCheck = userTempData.find((user: any) => user.id === selectData.id);
    if (isCheck !== undefined) {
      const prevData = this.state.UsersAllData.find(
        (x: any) => x.id === isCheck.id
      );
      let index = userTempData.indexOf(isCheck);
      userTempData.splice(index, 1);
      isCheck.isSupport = args.isChecked;
      isCheck.isAdmin = prevData.isAdmin;
      isCheck.isApprover = prevData.isApprover;
      isCheck.Status = prevData.Status;
      isCheck.isChecked = args.isChecked;
      userTempData.push(isCheck);
    } else {
      selectData.isSupport = args.isChecked;
      selectData.isChecked = args.isChecked;
      userTempData.push(selectData);
    }
    this.setState({ UsersTempData: userTempData });
  }
  oncChanceListComponents(args: any) {
    let componentTempData = this.state.ComponentsTempData;
    let selectData: any = args.data;
    const company_id = this.grid.getSelectedRecords()[0].id;

    const isCheck = componentTempData.find(
      (user: any) => user.component_id === selectData.id
    );
    if (isCheck !== undefined) {
      let index = componentTempData.indexOf(isCheck);
      componentTempData.splice(index, 1);
    } else {
      const obj = {
        id: company_id,
        Description: selectData.description,
        text: selectData.text,
        component_id: selectData.id,
        Status: selectData.Status,
        isChecked: args.isChecked,
        isDeleted: true,
      };
      componentTempData.push(obj);
    }
    this.setState({ ComponentsTempData: componentTempData });
  }

  getCompany() {
    getCompany().then((res) => {
      const model = res.data.map((company: any) => {
        return {
          ...company,
          id: company.organization_id,
          Status: company.status,
          color: company.status ? '#339933' : '#C90016',
          sitesActiveText: company.status ? 'ACTIVE' : 'INACTIVE',
        };
      });
      if (this._isMounted) {
        this.setState({
          CompanyData: model,
        });
      }
      if (this.state.CompanyData.length > 0) {
        $('.collapse-section-two').css('display', 'block');
      } else {
        $('.collapse-section-two').css('display', 'none');
      }
    });
  }
  getSitess() {
    getSites().then((res) => {
      if (this._isMounted) {
        this.setState({
          CompanySitesData: res.data,
        });
      }
      if (this.state.CompanyData.length > 0) {
        $('.collapse-section-two').css('display', 'block');
      } else {
        $('.collapse-section-two').css('display', 'none');
      }
    });
  }
  addSite() {
    if (this.site_code === '') {
      Message.error('Site code cannot be empty');
      return;
    }
    if (this.description === '') {
      Message.error('Description cannot be empty');
      loadingShow(false);
      return;
    }
    loadingShow(true, 'Adding');
    const parentId = this.grid.getSelectedRecords()[0].id;
    const obj = {
      organization_code: this.site_code,
      status: this.status,
      isParent: false,
      description: this.description,
      parent_organization_id: parentId,
      app: 'UWORK',
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
    AddCampany(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getCompany();
        this.getSitesTemp(parentId);
        this.dialogCloseSiteAdd();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  getSitesTemp(companyId: any) {
    loadingShow(true);
    setTimeout(() => {
      let dataSites: any = [];
      let dataUsers: any = [];
      this.state.CompanySitesData.map((item: any) => {
        if (item.parent_organization_id === companyId) {
          dataSites.push(item);
        }
      });

      this.state.UsersAllData.map((item: any) => {
        if (item.company_id === companyId && item.isSupport === true) {
          dataUsers.push(item);
        }
      });
      this.setState({ SitesTempData: dataSites, UsersTempData: dataUsers });
      loadingShow(false);
    }, 2000);
  }
  fillInputBillingInformation = () => {
    const data = this.grid.getSelectedRecords()[0];
    $('#billing_organization').val(data.biling_org_name) as unknown as string;
    $('#billing_mail').val(data.email) as unknown as string;
    $('#billing_addressLine1').val(data.adress_line_1) as unknown as string;
    $('#billing_addressLine2').val(data.adress_line_2) as unknown as string;
    $('#billing_city').val(data.city) as unknown as string;
    $('#billing_stateProvince').val(data.state_province) as unknown as string;
    $('#billing_postalCode').val(data.postal_code) as unknown as string;
    $('#billing_country').val(data.country) as unknown as string;
    $('#billing_primaryContact').val(data.primary_contact) as unknown as string;
    $('#billing_contactNumber').val(data.contact_number) as unknown as string;
  };
  CleanInputBillingInformation = () => {
    $('#billing_organization').val('') as unknown as string;
    $('#billing_mail').val('') as unknown as string;
    $('#billing_addressLine1').val('') as unknown as string;
    $('#billing_addressLine2').val('') as unknown as string;
    $('#billing_city').val('') as unknown as string;
    $('#billing_stateProvince').val('') as unknown as string;
    $('#billing_postalCode').val('') as unknown as string;
    $('#billing_country').val('') as unknown as string;
    $('#billing_primaryContact').val('') as unknown as string;
    $('#billing_contactNumber').val('') as unknown as string;
    this.setState({
      SitesTempData: [],
      UsersTempData: [],
      ComponentsTempData: [],
      DepartmentTempData: [],
    });
  };
  AllCompanySave = () => {
    let company_id = 0;
    if (this.grid.getSelectedRecords().length !== 0) {
      company_id = this.grid.getSelectedRecords()[0].id;
    } else {
      Message.error('No records selected for edited operation');
      return false;
    }
    //billing information
    this.addBilling(company_id);
    //sites
    //department
    //users
    // this.addAllUsers(company_id);

    //component
    this.addAllComponent(company_id);
  };
  addBilling = (company_id: any) => {
    const companyData = this.grid.getSelectedRecords()[0];
    const biling_org_name = $('#billing_organization').val() as string;
    const email = $('#billing_mail').val() as string;
    const adress_line_1 = $('#billing_addressLine1').val() as string;
    const adress_line_2 = $('#billing_addressLine2').val() as string;
    const city = $('#billing_city').val() as string;
    const state_province = $('#billing_stateProvince').val() as string;
    const postal_code = $('#billing_postalCode').val() as string;
    const country = $('#billing_country').val() as string;
    const primary_contact = $('#billing_primaryContact').val() as string;
    const contact_number = $('#billing_contactNumber').val() as string;

    const startDate = companyData.effective_start_date;
    const endtDate = companyData.effective_end_date;
    loadingShow(true);
    const obj = {
      ...companyData,
      effective_start_date: new Date(startDate),
      effective_end_date: new Date(endtDate),
      CompanyName: companyData.text,
      Abc: companyData.Abc,
      Abn: companyData.Abn,
      PaymentTerms: companyData.payment_terms,
      Status_Id: companyData.Status_Id,
      isParent: true,
      organization_id: company_id,
      Adaptor_Id: companyData.Adaptor_Id,
      generalNot: this.textareaObjGeneral.value,
      accountNot: this.textareaObjAccount.value,
      internalNot: this.textareaObjInternal.value,
      biling_org_name,
      email,
      adress_line_1,
      adress_line_2,
      city,
      state_province,
      postal_code,
      country,
      primary_contact,
      contact_number,
      app: 'UWORK',
      created_by: all_information.user_id,
      creation_date: new Date()
    };
    delete obj.rowstamp;
    EditCampany(obj)
      .then((result: any) => {
        this.getCompany();
        Message.success("Success")
        loadingShow(false);
      })
      .catch((err: any) => {
        Message.error("Error occured")
        loadingShow(false);
      });
  };
  addAllSite = (company_id: any) => {
    if (this.state.SitesTempData.length > 0) {
      this.state.SitesTempData.map((item: any) => {
        loadingShow(true);
        const obj = {
          organization_code: item.text,
          status: item.Status,
          isParent: false,
          description: item.s_description,
          organization_id: item.id,
          parent_organization_id: item.s_parent_organization_id,
        };
        EditCampany(obj)
          .then((res: any) => {
            this.getCompany();
            loadingShow(false);
          })
          .catch((err: any) => {
            loadingShow(false);
          });
      });
    }
  };
  addAllDepartment = (company_id: any) => {
    if (this.state.DepartmentTempData.length > 0) {
      this.state.DepartmentTempData.map((item: any) => {
        const data = this.grid.getSelectedRecords()[0];
        loadingShow(true);
        const obj = {
          status: item.status,
          description: item.description,
          department_id: item.id,
          department_code: item.text,
          organization_id: item.company_id,
          organization_code: data.text,
        };
        //(obj);
        EditDepartment(obj)
          .then((res: any) => {
            this.getDeparments();
            loadingShow(false);
          })
          .catch((err: any) => {
            loadingShow(false);
          });
      });
    }
  };
  addAllUsers = (company_id: any) => {
    // if (this.state.UsersTempData.length > 0) {
    //   this.state.UsersTempData.map((user: any) => {
    //     loadingShow(true);
    //     let obj = {
    //       password: user.password,
    //       status: user.status,
    //       lock_account: user.lock_account,
    //       application_user_id: user.application_user_id,
    //       assignment_security_roles: user.assignment_security_roles_id,
    //       department_id: user.department_id,
    //       department_name: user.department_name,
    //       company_id: user.company_id,
    //       company_name: user.company_name,
    //       site_id: user.site_id,
    //       site_name: user.site_name,
    //       assignment_id: user.assignment_id,
    //       assignment_name: '-',
    //       locale: user.locale,
    //       email: user.email,
    //       first_name: user.first_name,
    //       last_name: user.last_name,
    //       user_id: user.id,
    //       isAdmin: user.isAdmin,
    //       isAprover: user.isApprover,
    //       isSupport: user.isSupport,
    //       contact_number: user.contactNumber,
    //     };
    //     editusers(obj)
    //       .then((el) => {
    //         this.getUsers();
    //         loadingShow(false);
    //       })
    //       .catch((el) => {
    //         Message.error(el);
    //         loadingShow(false);
    //       });
    //   });
    // }
  };
  addAllComponent = async (company_id: any) => {
    if (this.state.ComponentsTempData.length > 0) {
      const model = this.state.ComponentsTempData.map((item: any) => {
        return {
          Organization_id: item.id,
          component_name: item.text,
          component_id: item.component_id,
          Description: item.Description,
          Status: item.Status,
        };
      });
      loadingShow(true);
      const obj = {
        Organization_Id: company_id,
        isDeleted: true,
        ListOrgAppComponent: model,
      };
      AddAppComponent(obj).then((res: any) => {
        this.getCompany();
        this.getComponents();
        this.getOrgComponents();
        loadingShow(false);
      });
    }
  };
  AllCompanyCancel = () => {
    loadingShow(true);
    setTimeout(() => {
      loadingShow(false);
      this.CleanInputBillingInformation();
      $('.content-show-sectionTwo').removeClass('show');
      $('#rotate-icon').removeClass('rotateIcon');
    }, 700);
  };
  setValuetest = (val: any) => {
    let obj = { allow: false, company_id: val.company_id };
    this.setState({ ci: obj });
  };
  triggerred = () => {
    this.getCompany();
    this.getUsers();
  };
  private onCreateGeneral(): void {
    this.textareaObjGeneral.addAttributes({ rows: 5 });
    this.textareaObjGeneral.respectiveElement.style.height = '100px';
  }
  private onInputGeneral(): void {
    this.textareaObjGeneral.respectiveElement.style.height = '100px';
  }
  private onCreateAccount(): void {
    this.textareaObjAccount.addAttributes({ rows: 5 });
    this.textareaObjAccount.respectiveElement.style.height = '100px';
  }
  private onInputAccount(): void {
    this.textareaObjAccount.respectiveElement.style.height = '100px';
  }
  private onCreateInternal(): void {
    this.textareaObjInternal.addAttributes({ rows: 5 });
    this.textareaObjInternal.respectiveElement.style.height = '100px';
  }
  private onInputInternal(): void {
    this.textareaObjInternal.respectiveElement.style.height = '100px';
  }
  private onChangeAdaptor(args: any) {
    this.setState({ adaptor: args.target.itemData });
  }
  componentWillUnmount() {
    this._isMounted = false;
    // this.source.cancel('canceled');
  }

  render() {
    return (
      <div className='campany-portfolio' id='forDestroy'>
        {this.props.isOnlyCompany ? null : (
          <div className='header-company-fixed'>
            <button
              style={{ marginRight: '5px', width: '90px', height: '40px' }}
              className='btn btn-primary p-3 rounded-xl'
              onClick={() => this.AllCompanySave()}
            >
              Save
            </button>
            <button
              style={{ width: '90px', height: '40px' }}
              className='btn btn-secondary p-3'
              onClick={() => this.AllCompanyCancel()}
            >
              Cancel
            </button>
          </div>
        )}
        <div className='company-sub-content'>
          <div className='first-section-campany'>
            <GridComponent
              id='companytableElement'
              onClick={this.gridOnFocus}
              dataSource={this.state.CompanyData}
              editSettings={this.editOptions}
              toolbar={this.toolbarOptions}
              ref={(g) => (this.grid = g)}
              height='25vh'
              filterSettings={this.FilterOptions}
              allowFiltering={true}
              allowPaging={true}
              pageSettings={this.pageOptions}
              showColumnMenu={true}
              allowResizing={true}
              allowGrouping={true}
              allowExcelExport={true}
              showColumnChooser
              toolbarClick={this.toolbarClick.bind(this)}
              actionBegin={this.begin.bind(this)}
              gridLines='Both'
              queryCellInfo={this.cellRender}
              rowSelected={this.rowselect.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field='id'
                  headerText='Company ID'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='adaptor_name'
                  headerText='Adaptor Name'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='organization_code'
                  headerText='Company Name'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='effective_start_date'
                  headerText='Registration Start'
                  textAlign='Left'
                  format='dd/MM/yyyy'
                  type='date'
                />
                <ColumnDirective
                  field='effective_end_date'
                  headerText='Registration End'
                  textAlign='Left'
                  format='dd/MM/yyyy'
                  type='date'
                />
                <ColumnDirective
                  field='ABC'
                  headerText='Abc'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='ABN'
                  headerText='Abn'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='PaymentTerms'
                  headerText='Payment Terms'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='status_id'
                  headerText='Status'
                  textAlign='Left'
                  width={'70px'}
                />
              </ColumnsDirective>
              <Inject
                services={[
                  Edit,
                  Toolbar,
                  Filter,
                  Page,
                  ColumnChooser,
                  ExcelExport,
                  ColumnMenu,
                  Group,
                  Resize,
                ]}
              />
            </GridComponent>
          </div>
          {this.props.isOnlyCompany ? null : (
            <div>
              <div className='collapse-section-two'>
                <div
                  id='collapse-sectionTwoIcon'
                  className='collapse-sectionTwo-icon'
                >
                  <div>
                    <FiChevronDown id='rotate-icon' size={17} />
                  </div>
                </div>
                <div className='content-show-sectionTwo'>
                  <div className='second-section-campany'>
                    <div className='billing-information'>
                      <div className='header-second-section'>
                        <div className='second-section-text'>
                          <span>Billing Information</span>
                        </div>
                      </div>
                      <div className='responsive-layout-company'>
                        <div className='billing-group'>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                Organization
                              </label>
                              <TextBoxComponent
                                id='billing_organization'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Organization...'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>Email</label>
                              <TextBoxComponent
                                id='billing_mail'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Email...'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                Address Line1
                              </label>
                              <TextBoxComponent
                                id='billing_addressLine1'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Address Line1'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                Address Line2
                              </label>
                              <TextBoxComponent
                                id='billing_addressLine2'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Address Line2'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>City</label>
                              <TextBoxComponent
                                id='billing_city'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='City'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                State / Province
                              </label>
                              <TextBoxComponent
                                id='billing_stateProvince'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='state / province'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                Postal Code
                              </label>
                              <TextBoxComponent
                                id='billing_postalCode'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Postal Code'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                Country
                              </label>
                              <TextBoxComponent
                                id='billing_country'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Country'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                Primary Contact
                              </label>
                              <TextBoxComponent
                                id='billing_primaryContact'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Primary Contact'
                              />
                            </div>
                          </div>
                          <div
                            className='row'
                            style={{
                              marginBottom: '4px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div className='col-md-11'>
                              <label className='label-information'>
                                Contact Number
                              </label>
                              <TextBoxComponent
                                id='billing_contactNumber'
                                style={{ height: 25, fontSize: 11 }}
                                placeholder='Contact Number'
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className=' opetations'>
                      <div className='tab-sites-company'>
                        <button className='tab-button-company active-tab-button'>
                          Sites
                        </button>
                        <button className='tab-button-company'>
                          Department
                        </button>
                      </div>
                      <div id='showTabSite'>
                        <div>
                          <div
                            className='header-operation-layout'
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                            }}
                          >
                            <div
                              id='addfixedButton'
                              className='add-operation-icon'
                              onClick={this.dialogOpenSiteAdd.bind(this)}
                            >
                              <IoAddOutline size={23} />
                            </div>
                          </div>
                        </div>
                        <div className='responsive-layout-company'>
                          {this.state.SitesTempData.length > 0 ? (
                            <div className='border-div'>
                              {this.state.SitesTempData.map((el: any) =>
                                this.sitesTemplate(el)
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div style={{ display: 'none' }} id='showTabDepartment'>
                        <div>
                          <div
                            className='header-operation-layout'
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                            }}
                          >
                            <div
                              id='addfixedButton'
                              className='add-operation-icon departmentLocation'
                              onClick={this.dialogOpenDepartmentAdd.bind(this)}
                            >
                              <IoAddOutline size={23} />
                            </div>
                          </div>
                        </div>
                        <div className='responsive-layout-company'>
                          {this.state.DepartmentTempData.length > 0 ? (
                            <div className='border-div'>
                              {this.state.DepartmentTempData.map((el: any) =>
                                this.departmentTemplate(el)
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className='opetations'>
                      <div className='header-second-section'>
                        <div className='header-operation-layout'>
                          <div className='second-section-text'>
                            <span>Application Components Licenced</span>
                          </div>
                          <div>
                            <div className='action-icon-operations'>
                              <div
                                className='add-operation-icon'
                                style={{ display: 'none' }}
                              >
                                {/* <IoRemoveSharp size={23} /> */}
                              </div>
                              <div
                                className='add-operation-icon'
                                onClick={this.dialogOpenComponentList.bind(
                                  this
                                )}
                              >
                                <MdOutlinePlaylistAdd size={23} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='responsive-layout-company'>
                        {this.state.ComponentsTempData.length > 0 ? (
                          <div className='border-div'>
                            {this.state.ComponentsTempData.map((el: any) => (
                              <div
                                key={Math.random()}
                                className='component-list-item'
                              >
                                <label>{el.text}</label>
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className=' opetations'>
                      <div className='header-second-section'>
                        <div className='header-operation-layout'>
                          <div className='second-section-text'>
                            <span>Adminstrative & Support Contacts</span>
                          </div>
                          <div>
                            <div className='action-icon-operations'>
                              <div
                                className='add-operation-icon'
                                style={{ display: 'none' }}
                              >
                                {/* <IoRemoveSharp size={23} /> */}
                              </div>
                              <div
                                className='add-operation-icon'
                                onClick={this.dialogOpenUserList.bind(this)}
                              >
                                <MdOutlinePlaylistAdd size={23} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='responsive-layout-company'>
                        {this.state.UsersTempData.length > 0 ? (
                          <div className='border-div'>
                            {this.state.UsersTempData.map((el: any) =>
                              el.isSupport === true
                                ? this.usersTemplate(el)
                                : null
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='three-section-campany'>
                <AUM
                  GridHeight={'25vh'}
                  companyObj={this.state.ci}
                  change={this.setValuetest.bind(this)}
                  triggered={this.triggerred.bind(this)}
                />
              </div>
              <div className='four-section-campany'>
                <div className='col-md-12'>
                  <div className='col-md-4'>
                    <div>
                      <div>
                        <TextBoxComponent
                          multiline={true}
                          value={this.state.richGeneralValue}
                          input={
                            (this.onInputGeneral =
                              this.onInputGeneral.bind(this))
                          }
                          created={
                            (this.onCreateGeneral =
                              this.onCreateGeneral.bind(this))
                          }
                          placeholder='General Notes'
                          floatLabelType='Auto'
                          ref={(scope) => {
                            this.textareaObjGeneral = scope;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div>
                      <div>
                        <TextBoxComponent
                          multiline={true}
                          value={this.state.richAccountValue}
                          input={
                            (this.onInputAccount =
                              this.onInputAccount.bind(this))
                          }
                          created={
                            (this.onCreateAccount =
                              this.onCreateAccount.bind(this))
                          }
                          placeholder='Account Notes'
                          floatLabelType='Auto'
                          ref={(scope) => {
                            this.textareaObjAccount = scope;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div>
                      <div>
                        <TextBoxComponent
                          multiline={true}
                          value={this.state.richInternalValue}
                          input={
                            (this.onInputInternal =
                              this.onInputInternal.bind(this))
                          }
                          created={
                            (this.onCreateInternal =
                              this.onCreateInternal.bind(this))
                          }
                          placeholder='Internal Notes'
                          floatLabelType='Auto'
                          ref={(scope) => {
                            this.textareaObjInternal = scope;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className='col-md-12'
                    style={{
                      marginTop: '10px',
                      paddingLeft: '13px',
                      paddingRight: '13px',
                    }}
                  >
                    <div>
                      <div>
                        <label className='footer-label-text'>
                          Company Document
                        </label>
                      </div>
                      <div>
                        <UploaderComponent
                          autoUpload={false}
                          asyncSettings={this.path}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  {this.state.hideDialog ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultdialog'
                      showCloseIcon={true}
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialog}
                      header='Company Registration'
                      width={500}
                      height={550}
                      buttons={this.buttons}
                      open={this.dialogOpen.bind(this)}
                      close={this.dialogClose.bind(this)}
                    >
                      <div style={{ marginTop: '30px' }} className='row'>
                        <div className='col-md-12'>
                          <div className='col-md-7'>
                            <div style={{ marginBottom: '10px' }}>
                              <span>Company Name</span>
                              <TextBoxComponent
                                id='companyName'
                                value={this.state.companyName}
                                style={{ height: 25 }}
                                placeholder='Company Name'
                              />
                            </div>
                            <div style={{ marginBottom: '10px' }}>
                              <span>Adaptor Name</span>
                              <DropDownListComponent
                                id='adaptorName'
                                value={this.state.adaptor.AdaptorID}
                                text={this.state.adaptor.AdaptorName}
                                fields={this.fields}
                                dataSource={this.state.adaptorData}
                                onChange={this.onChangeAdaptor.bind(this)}
                                style={{ height: 25 }}
                                placeholder='Adaptor Name'
                              />
                            </div>
                            <div style={{ marginBottom: '10px' }}>
                              <span>Registration Start</span>
                              <DatePickerComponent
                                id='registrationStartDate'
                                style={{ height: 25 }}
                                value={this.state.registrationStartDate}
                                format='dd/MM/yyyy'
                                placeholder='Registration Start'
                                onChange={this.onChangeRegistrationDate}
                              />
                            </div>
                            <div style={{ marginBottom: '10px' }}>
                              <span>Registration End</span>
                              <DatePickerComponent
                                id='registrationEndDate'
                                value={this.state.registrationEndDate}
                                style={{ height: 25 }}
                                format='dd/MM/yyyy'
                                placeholder='Registration End'
                                onChange={this.onChangeRegistrationDate}
                              />
                            </div>
                            <div style={{ marginBottom: '10px' }}>
                              <span>ABN</span>
                              <TextBoxComponent
                                id='abn'
                                value={this.state.abn}
                                style={{ height: 25 }}
                                placeholder='ABN'
                              />
                            </div>
                            <div style={{ marginBottom: '10px' }}>
                              <span>ACN</span>
                              <TextBoxComponent
                                id='abc'
                                value={this.state.abc}
                                style={{ height: 25 }}
                                placeholder='ACN'
                              />
                            </div>
                            <div style={{ marginBottom: '10px' }}>
                              <span>Payment Terms</span>
                              <TextBoxComponent
                                id='paymentTerms'
                                value={this.state.paymetnTerms}
                                style={{ height: 25 }}
                                placeholder='Payment Terms'
                              />
                            </div>
                          </div>
                          <div className='col-md-5'>
                            <div
                              style={{ marginBottom: '10px' }}
                              className='company-logo'
                            >
                              <div>
                                <label
                                  className='company-logo-text'
                                  style={{ fontSize: '20px' }}
                                >
                                  Company Logo
                                </label>
                              </div>
                              <div className='company-logo-image'>
                                <span>320x200</span>
                              </div>

                              <div className='company-logo-button-action'>
                                <button className='btn btn-secondary'>
                                  Clear
                                </button>
                                <button
                                  style={{ marginLeft: '3px' }}
                                  className='btn btn-secondary'
                                >
                                  Upload
                                </button>
                              </div>
                            </div>
                            <div
                              style={{
                                display: this.state.statusHide
                                  ? 'block'
                                  : 'none',
                              }}
                            >
                              <span>Registration Status</span>
                              <div className='registration-status'>
                                <button
                                  id='aktiveACTIVE'
                                  style={{
                                    display: this.state.activeStatus
                                      ? 'block'
                                      : 'none',
                                  }}
                                  className='btn btn-success'
                                >
                                  ACTIVE
                                </button>
                                <button
                                  id='aktiveWARNING'
                                  style={{
                                    marginLeft: '5px',
                                    display: this.state.warningStatus
                                      ? 'block'
                                      : 'none',
                                  }}
                                  className='btn btn-warning'
                                >
                                  WARNING
                                </button>
                                <button
                                  id='aktiveINACTIVE'
                                  style={{
                                    marginLeft: '5px',
                                    display: this.state.inactiveStatus
                                      ? 'block'
                                      : 'none',
                                  }}
                                  className='btn btn-danger'
                                >
                                  INACTIVE
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  {this.state.hideDialogUsersList ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultdialog'
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogUsersList}
                      header='Users List'
                      width={500}
                      height={'auto'}
                      buttons={this.buttonsUsersList}
                      open={this.dialogOpenUserList.bind(this)}
                      close={this.dialogCloseUsersList.bind(this)}
                    >
                      <div className='row' style={{ margin: '5px' }}>
                        <ListViewComponent
                          id='list'
                          select={this.oncChanceListUsers.bind(this)}
                          dataSource={this.state.UsersListCheckboxData}
                          showCheckBox={true}
                          headerTitle='Select Users'
                          showHeader={true}
                          ref={(scope) => {
                            this.listObj = scope;
                          }}
                        ></ListViewComponent>
                      </div>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  {this.state.hideDialogSitesAdd ? (
                    <DialogComponent
                      animationSettings={{
                        delay: 1,
                        duration: 500,
                        effect: 'FadeZoom',
                      }}
                      visible={this.state.hideDialogSitesAdd}
                      header='Create a Site'
                      close={this.dialogCloseSiteAdd}
                      open={this.dialogOpenSiteAdd}
                      buttons={this.buttonForAdd}
                      isModal
                      width={'200px'}
                    >
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <div className='col-md-12'>
                              <TextBoxComponent
                                placeholder='Site Code'
                                id='siteName'
                                floatLabelType='Auto'
                                value={this.site_code}
                                onChange={(el: any) => {
                                  this.site_code = el.value;
                                }}
                              />
                            </div>

                            <div className='col-md-12'>
                              <TextBoxComponent
                                placeholder='Description'
                                id='siteDesc'
                                floatLabelType='Auto'
                                value={this.description}
                                onChange={(e: any) => {
                                  this.description = e.value;
                                }}
                              />
                            </div>

                            <div
                              className='col-md-12'
                              style={{ marginTop: 20 }}
                            >
                              <div className='col-md-7'>Status</div>
                              <div className='col-md-5'>
                                <SwitchComponent
                                  id='swichActiveOrInActive'
                                  change={(e: any) => {
                                    this.status = e.checked;
                                  }}
                                  checked={this.status}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  {this.state.hideDialogDepartmentAdd ? (
                    <DialogComponent
                      animationSettings={{
                        delay: 1,
                        duration: 500,
                        effect: 'FadeZoom',
                      }}
                      visible={this.state.hideDialogDepartmentAdd}
                      header='Create a Department'
                      close={this.dialogCloseDepartmentAdd}
                      open={this.dialogOpenDepartmentAdd}
                      buttons={this.buttonForAddDepartment}
                      isModal
                      width={'200px'}
                    >
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12'>
                            <div className='col-md-12'>
                              <TextBoxComponent
                                placeholder='Department Name'
                                id='departmentName'
                                floatLabelType='Auto'
                                value={this.department_code}
                                onChange={(el: any) => {
                                  this.department_code = el.value;
                                }}
                              />
                            </div>

                            <div className='col-md-12'>
                              <TextBoxComponent
                                id='departmentDesc'
                                placeholder='Description'
                                floatLabelType='Auto'
                                value={this.descriptionDepartment}
                                onChange={(e: any) => {
                                  this.descriptionDepartment = e.value;
                                }}
                              />
                            </div>

                            <div
                              className='col-md-12'
                              style={{ marginTop: 20 }}
                            >
                              <div className='col-md-7'>Status</div>
                              <div className='col-md-5'>
                                <SwitchComponent
                                  id='swichActiveOrInActive'
                                  change={(e: any) => {
                                    this.statusDepartment = e.checked;
                                  }}
                                  checked={this.statusDepartment}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  {this.state.hideDialogComponentList ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultdialog'
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogComponentList}
                      header='Components List'
                      width={500}
                      height={'auto'}
                      buttons={this.buttonsComponentList}
                      open={this.dialogOpenComponentList.bind(this)}
                      close={this.dialogCloseComponentList.bind(this)}
                    >
                      <div className='row' style={{ margin: '5px' }}>
                        <ListViewComponent
                          id='list'
                          select={this.oncChanceListComponents.bind(this)}
                          dataSource={this.state.ComponentsListCheckboxData}
                          showCheckBox={true}
                          headerTitle='Select Components'
                          showHeader={true}
                          ref={(scope) => {
                            this.listObj = scope;
                          }}
                        ></ListViewComponent>
                      </div>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  {this.state.hideDialogDeleteCompany ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultDialogDelete'
                      showCloseIcon={true}
                      visible={this.state.hideDialogDeleteCompany}
                      header='Confirmation'
                      width={200}
                      height={'auto'}
                      buttons={this.buttonForDelete}
                      open={() => {
                        this.setState({ hideDialogDeleteCompany: true });
                      }}
                      close={() => {
                        this.setState({ hideDialogDeleteCompany: false });
                      }}
                    >
                      <div className='container'>
                        <div className='row'>
                          <span>Are you sure?</span>
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
